import { Services } from "appworks/services/services";
import { ButtonControl } from "./button-control";

export class AutoStopControl extends ButtonControl {
    protected onClick(): void {
        Services.autoplay.stop();
    }
}
